/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerBulkUpdateMutationRequest, TasksControllerBulkUpdateMutationResponse, TasksControllerBulkUpdate400, TasksControllerBulkUpdate401 } from "../../models/tasksController/TasksControllerBulkUpdate";

function getTasksControllerBulkUpdateUrl() {
  const res = { method: 'PATCH', url: `/api/v1/tasks` as const }  
  return res
}

/**
 * @description Update multiple tasks in one call. Each item specifies its own attributes to change. Supports partial success — failed items are reported per-item without blocking others. Returns 200 if all items succeed, 207 Multi-Status if any fail.
 * @summary Bulk update tasks
 * {@link /api/v1/tasks}
 */
export async function tasksControllerBulkUpdate(data: TasksControllerBulkUpdateMutationRequest, config: Partial<RequestConfig<TasksControllerBulkUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TasksControllerBulkUpdateMutationResponse, ResponseErrorConfig<TasksControllerBulkUpdate400 | TasksControllerBulkUpdate401>, TasksControllerBulkUpdateMutationRequest>({ method : "PATCH", url : getTasksControllerBulkUpdateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}